import { STRENGTHS } from '../content'
import { anim, stagger } from '../motion'
import { Box, Check, Phone, Shape } from '../primitives'
import { PHONE } from './SceneInvitation'

const PROMISES = [
  'Persönliches Feedback direkt nach dem letzten Spiel',
  'Ein echter Mehrwert, auch bei einer Absage',
  'Eine Candidate Experience, die für dich spricht'
]

const BURST = [
  { kind: 'tri', color: 'yellow', x: -70, y: -40, r: -20 },
  { kind: 'sq', color: 'green', x: 80, y: -50, r: 25 },
  { kind: 'dot', color: 'pink', x: -90, y: 30, r: 0 },
  { kind: 'sq', color: 'blue', x: 96, y: 24, r: -15 }
]

export default function SceneFeedback() {
  return (
    <>
      <Box
        x={40}
        y={150}
        w={460}
        h={270}
        className='sty-card sty-pad-lg'
        style={anim({ at: [0.04, 0.16], x: -30, y: 0 })}
      >
        <div className='sty-eyebrow'>Für jedes Talent</div>
        <div className='sty-h3 sty-mt-1'>Sofort. Persönlich. Für alle.</div>
        <div className='sty-mt-4'>
          {PROMISES.map((text, i) => (
            <div
              key={text}
              className='sty-row sty-mt-3'
              style={anim({ at: stagger(0.18, 0.06, 0.1, i), x: -16, y: 0 })}
            >
              <Check />
              <span>{text}</span>
            </div>
          ))}
        </div>
      </Box>

      <Phone x={PHONE.x} y={PHONE.y}>
        <div className='sty-abs sty-screen'>
          <div className='sty-feedback-head'>
            {BURST.map((b, i) => (
              <div key={i} className='sty-abs' style={{ left: 104, top: 34 }}>
                <div
                  style={anim({
                    at: [0.04, 0.2],
                    x: -b.x,
                    y: -b.y,
                    s: 0.2,
                    r: b.r
                  })}
                >
                  <div style={{ transform: `translate(${b.x}px, ${b.y}px)` }}>
                    <Shape
                      kind={b.kind}
                      color={b.color}
                      size={20}
                      rotate={b.r}
                    />
                  </div>
                </div>
              </div>
            ))}
            <div
              className='sty-h4 sty-center'
              style={anim({ at: [0.06, 0.16], y: 10 })}
            >
              Dein Stärkenprofil
            </div>
          </div>
          {STRENGTHS.map((s, i) => (
            <div
              key={s.title}
              className='sty-strength'
              style={anim({ at: stagger(0.16, 0.08, 0.12, i), y: 24 })}
            >
              <Shape kind={s.shape} color={s.color} size={26} />
              <div>
                <div className='sty-strong'>{s.title}</div>
                <div className='sty-muted sty-small'>{s.text}</div>
              </div>
            </div>
          ))}
        </div>
      </Phone>
    </>
  )
}
